/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
export default class GoalsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let person = this.modelFor('people.person').person;
    let pageModel = this.modelFor('people.person.page');
    let page = pageModel.page;
    let assessments = page.assessment_ids;
    // assessments is a fragment array: spread it, or stringify reaches the store.
    let assessmentIds = JSON.stringify([...assessments]);

    let {
      categories,
      levels,
      milestones,
      subcategories,
      goals,
      expectations,
      progressions,
      subjectSummaries,
    } = this.modelFor('people.person.page');
    return hash({
      modules: this.store.query('assessments/module', {
        assessmentIds,
        include: 'gradeSchedules',
      }),
      person,
      page,
      categories,
      levels,
      milestones,
      subcategories,
      goals,
      expectations,
      progressions,
      subjectSummaries,
    });
  }
}
